(function () {
  const modal = document.getElementById('STCodModal');
  const form = document.getElementById('STCodForm');
  const cfg = document.getElementById('STCodConfig');
  if (!modal || !form || !cfg) return;

  const sec = window.STSecurity || {};
  const sanitize = (v, max) => (sec.sanitizeText ? sec.sanitizeText(v, max) : String(v || '').trim().slice(0, max || 999));

  const wa = (cfg.dataset.wa || '').replace(/\D/g, '');
  const shopName = cfg.dataset.shop || 'Tienda';
  const currency = cfg.dataset.currency || 'EUR';
  const intro = cfg.dataset.msgIntro || 'Hola, confirmo pedido CONTRA REEMBOLSO:';

  const routes = window.ST_ROUTES || {};
  const cartAdd = routes.cart_add || '/cart/add.js';

  let pending = null;

  function openModal(payload) {
    pending = payload;
    const summary = modal.querySelector('[data-cod-summary]');
    if (summary && payload.lines?.length) {
      summary.hidden = false;
      summary.textContent = payload.lines.map((l) => `${sanitize(l.title, 120)} ×${Number(l.qty) || 1}`).join(' · ');
    } else if (summary) {
      summary.hidden = true;
    }
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function formatMoney(cents) {
    const n = (Number(cents) / 100).toFixed(2);
    return currency === 'EUR' ? `€${n.replace('.', ',')}` : `${currency} ${n}`;
  }

  async function addToCart(variantId, quantity, properties) {
    const res = await fetch(cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity, properties }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'No se pudo añadir al carrito');
    }
    return res.json();
  }

  function buildWhatsAppUrl(data, cart) {
    const lines = (cart?.items || pending?.lines || []).map((item) => {
      const title = item.product_title || item.title;
      const qty = item.quantity || item.qty;
      const price = item.final_line_price != null ? formatMoney(item.final_line_price) : item.priceLabel || '';
      return `• ${title} ×${qty}${price ? ` — ${price}` : ''}`;
    });

    const total = cart?.total_price != null
      ? formatMoney(cart.total_price)
      : pending?.totalLabel || '';

    const text = [
      intro,
      '',
      `🛒 ${shopName}`,
      '',
      '📦 Productos:',
      ...lines,
      '',
      `💰 Total: ${total}`,
      '💳 Pago: Contra reembolso (COD)',
      '',
      '👤 Datos:',
      `Nombre: ${data.name}`,
      `Tel: ${data.phone}`,
      data.email ? `Email: ${data.email}` : '',
      `Dirección: ${data.address}`,
      data.notes ? `Notas: ${data.notes}` : '',
      '',
      '✅ Por favor confirmad mi pedido por WhatsApp. Gracias.',
    ].filter(Boolean).join('\n');

    return `https://wa.me/${wa}?text=${encodeURIComponent(text)}`;
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-cod-open]');
    if (!trigger) return;
    e.preventDefault();

    const variantId = trigger.dataset.variantId;
    const qty = Number(trigger.dataset.quantity || 1);
    const title = trigger.dataset.title || '';
    const price = trigger.dataset.price || '';

    if (variantId) {
      openModal({
        variantId,
        quantity: qty,
        lines: [{ title, qty, priceLabel: price }],
        totalLabel: price,
      });
      return;
    }

    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        if (!cart.item_count) {
          alert('El carrito está vacío');
          return;
        }
        openModal({
          lines: cart.items.map((i) => ({
            title: i.product_title,
            qty: i.quantity,
            priceLabel: formatMoney(i.final_line_price),
          })),
          totalLabel: formatMoney(cart.total_price),
          fromCart: true,
        });
      })
      .catch(() => alert('No se pudo cargar el carrito'));
  });

  modal.querySelectorAll('[data-cod-close]').forEach((el) => {
    el.addEventListener('click', closeModal);
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!wa) {
      alert('WhatsApp no configurado en Theme settings');
      return;
    }

    const fd = new FormData(form);
    const data = {
      name: sanitize(fd.get('name'), 80),
      phone: sanitize(fd.get('phone'), 24).replace(/[^\d+\s()-]/g, ''),
      email: sanitize(fd.get('email'), 120),
      address: sanitize(fd.get('address'), 240),
      notes: sanitize(fd.get('notes'), 200),
    };

    if (!data.name || !data.phone || !data.address) {
      alert('Completa nombre, teléfono y dirección');
      return;
    }
    if (data.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      alert('Email no válido');
      return;
    }

    const props = {
      'Pago': 'Contra reembolso (COD)',
      'Cliente': data.name,
      'Teléfono': data.phone,
    };
    if (data.email) props['Email'] = data.email;
    if (data.address) props['Dirección'] = data.address;
    if (data.notes) props['Notas'] = data.notes;

    const btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;

    try {
      let cart = null;
      if (pending?.variantId) {
        await addToCart(pending.variantId, pending.quantity || 1, props);
      } else if (pending?.fromCart) {
        const cartRes = await fetch('/cart.js');
        cart = cartRes.ok ? await cartRes.json() : null;
        for (const item of cart?.items || []) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              id: item.key,
              quantity: item.quantity,
              properties: { ...item.properties, ...props },
            }),
          });
        }
      }

      const cartRes = await fetch('/cart.js');
      cart = cartRes.ok ? await cartRes.json() : cart;

      const url = buildWhatsAppUrl(data, cart);
      closeModal();
      window.open(url, '_blank', 'noopener,noreferrer');

      document.dispatchEvent(new CustomEvent('cod:confirmed', { detail: { data, cart } }));
    } catch (err) {
      alert(err.message || 'Error al procesar el pedido');
    } finally {
      if (btn) btn.disabled = false;
    }
  });
})();
